import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine conditional class names and resolve conflicting Tailwind utilities.
 *
 * `clsx` flattens the conditional inputs into a single class string and
 * `tailwind-merge` then dedupes conflicting Tailwind classes (the later class
 * wins, e.g. `cn('p-2', 'p-4')` → `'p-4'`). Shared across apps and libs so
 * every React/Tailwind surface composes class names the same way.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
